/**
 * Soft location-suggestion banner for base FusionMSI marketing pages (PROMPT B).
 * Never silently swaps content — visitor must click through.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Alert, Box, Button } from '@mui/material';
import {
  isFusionMsiBaseMarketingPath,
  isGeoMarketingPath,
} from '../marketing/fusionMsiMarketingRouting';
import useMarketingLocationSuggestion from '../marketing/useMarketingLocationSuggestion';

function GeoLocationSuggestBanner() {
  const { pathname } = useLocation();
  const onBaseMarketing =
    isFusionMsiBaseMarketingPath(pathname) && !isGeoMarketingPath(pathname);
  const { suggestion, dismiss } = useMarketingLocationSuggestion({
    enabled: onBaseMarketing,
  });

  if (!onBaseMarketing || !suggestion) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        px: 2,
        pt: 1,
      }}
    >
      <Alert
        severity="info"
        onClose={dismiss}
        action={
          <Button
            component={RouterLink}
            to={suggestion.href}
            color="inherit"
            size="small"
            variant="outlined"
            onClick={dismiss}
          >
            View page
          </Button>
        }
      >
        Looks like you&apos;re near {suggestion.label} — view the regional page?
      </Alert>
    </Box>
  );
}

GeoLocationSuggestBanner.propTypes = {};

export default GeoLocationSuggestBanner;
